module.exports = __webpack_public_path__ + "c4f0a5040f557cf07b4510df649068d1.jpg";